import PropTypes from 'prop-types';
import styles from './FJFavorite.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJVoiceItemContainer from '../../../FJTextToSpeech/FJTextToSpeechRight/container/FJVoiceItemContainer.jsx';
import FJFavoriteEmptyBase64 from '../../../../assets/base64/favorite-empty.js';
import FJAutoLoading from '../../../../common/components/FJLoading/FJAutoLoading.jsx';
import FJOppsIcon from '../../../../assets/svg/oops.svg?react';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJLoading from '../../../../common/components/FJLoading/FJLoading.jsx';

const FJFavorite = props => {
    const { favoriteVoiceList, onUse, loadingStatus, onRetry, stateMaxCount } = props;

    return (
        <>
            {loadingStatus === FJConstant.LOADING && (
                <div className={styles.state_box}>
                    <FJAutoLoading shown strokeColor='#9FA2AF' />
                </div>
            )}
            {favoriteVoiceList.length === 0 && loadingStatus === FJConstant.ERROR && (
                <div className={styles.state_box}>
                    <FJOppsIcon />
                    <div className={styles.retry_desc}>{FJLocalStore._('unknown-error-please-try-again')}</div>
                    <FJButton text='retry' className={styles.retry_btn} onClick={onRetry} />
                </div>
            )}
            {favoriteVoiceList.length === 0 && loadingStatus === FJConstant.SUCCESS && (
                <div className={styles.state_box}>
                    <img src={FJFavoriteEmptyBase64} alt='' />
                    <div className={styles.empty_desc}>{FJLocalStore._('no-favorites-yet')}</div>
                </div>
            )}
            {favoriteVoiceList.length > 0 && loadingStatus === FJConstant.SUCCESS && (
                <>
                    {favoriteVoiceList.slice(0, stateMaxCount).map(item => {
                        return (
                            <FJVoiceItemContainer
                                key={item.value}
                                info={item}
                                onUse={onUse}
                                fromType={item.type || FJConstant.MICROSOFT}
                            />
                        );
                    })}
                    <div className={styles.bottom}>
                        {stateMaxCount >= favoriteVoiceList.length ? (
                            <div className={styles.end}>{FJLocalStore._('scroll-end-tip')}</div>
                        ) : (
                            <FJLoading strokeColor='#a8acbc' />
                        )}
                    </div>
                </>
            )}
        </>
    );
};
FJFavorite.propTypes = {
    voiceList: PropTypes.array,
    favoriteVoiceList: PropTypes.array,
    voiceCloneList: PropTypes.array,
    onClose: PropTypes.func,
    onUse: PropTypes.func,
    loadingStatus: PropTypes.string,
    onRetry: PropTypes.func,
    stateMaxCount: PropTypes.number,
};
export default FJFavorite;
